var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5195_133329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5195_133329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4551 12L9.25782 7.80269C9.06051 7.60538 8.96185 7.35426 8.96185 7.04933C8.96185 6.74439 9.06051 6.49327 9.25782 6.29596C9.45513 6.09865 9.70625 6 10.0112 6C10.3161 6 10.5672 6.09865 10.7645 6.29596L15.7152 11.2466C15.9305 11.4619 16.0381 11.713 16.0381 12C16.0381 12.287 15.9305 12.5381 15.7152 12.7534L10.7645 17.704C10.5672 17.9013 10.3161 18 10.0112 18C9.70625 18 9.45513 17.9013 9.25782 17.704C9.06051 17.5067 8.96185 17.2556 8.96185 16.9507C8.96185 16.6457 9.06051 16.3946 9.25782 16.1973L13.4551 12Z",
    fill: "#1E1531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/keyboard_arrow_right.e36e437f1beed1f6b0c60b9b60626d5e.svg";
export { ForwardRef as ReactComponent };